<template>
  <v-menu
    v-model="isMenuOpen"
    offset-y
    left
    nudge-bottom="22"
    :close-on-content-click="false"
    min-width="360"
    max-width="360"
    :elevation="$vuetify.theme.dark ? 9 : 8"
    content-class="list-style cart-menu-content"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-badge
        :value="count > 0"
        :content="String(count)"
        color="primary"
        overlap
      >
        <v-icon
          v-bind="attrs"
          v-on="on"
        >
          {{ icons.mdiCartOutline }}
        </v-icon>
      </v-badge>
    </template>
    <v-card class="app-bar-cart-content-container">
      <perfect-scrollbar
        class="ps-cart-items"
        :options="perfectScrollbarOptions"
      >
        <v-list class="py-0">
          <!-- Заголовок -->
          <v-list-item class="d-flex">
            <div class="d-flex align-center justify-space-between flex-grow-1">
              <span class="font-weight-semibold">{{ $t('Корзина') }}</span>
              <v-chip
                v-if="count > 0"
                class="v-chip-light-bg primary--text font-weight-semibold"
                small
              >
                {{ count }}
              </v-chip>
            </div>
          </v-list-item>
          <v-divider></v-divider>

          <!-- Заявки в корзине -->
          <template v-for="(item, index) in items">
            <v-list-item :key="'c' + item.id">
              <v-list-item-content class="d-block">
                <v-list-item-title class="text-sm font-weight-semibold">
                  {{ $t('Заявка') }} №{{ item.id }}
                </v-list-item-title>
                <v-list-item-subtitle class="text-xs">
                  {{ item.museum }} · {{ item.date }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  icon
                  small
                  :title="$t('Убрать из корзины')"
                  @click="removeItem(item.id)"
                >
                  <v-icon small>
                    {{ icons.mdiClose }}
                  </v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-divider :key="index"></v-divider>
          </template>

          <!-- Пусто -->
          <v-list-item
            v-if="count === 0"
            key="empty-cart"
          >
            <v-list-item-content>
              <v-list-item-subtitle class="text-sm text-center">
                {{ $t('Корзина пуста') }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <!-- Кнопки -->
          <v-list-item
            v-if="count > 0"
            key="cart-actions"
            class="cart-btn-list-item"
          >
            <div class="flex-grow-1">
              <v-btn
                block
                color="primary"
                @click="paySelected"
              >
                {{ $t('Оплатить') }}
              </v-btn>
              <v-btn
                block
                text
                small
                class="mt-2"
                @click="clearCart"
              >
                {{ $t('Очистить') }}
              </v-btn>
            </div>
          </v-list-item>
        </v-list>
      </perfect-scrollbar>
    </v-card>
  </v-menu>
</template>

<script>
import store from '@/store'
import { computed, ref } from '@vue/composition-api'
import { useRouter } from '@core/utils'
import { mdiCartOutline, mdiClose } from '@mdi/js'

// 3rd Party
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'

export default {
  components: {
    // 3rd Party
    PerfectScrollbar,
  },
  setup() {
    const { router } = useRouter()
    const isMenuOpen = ref(false)

    const items = computed(() => store.getters['cart/getItems'])
    const count = computed(() => store.getters['cart/getCount'])

    const removeItem = id => store.commit('cart/remove', id)
    const clearCart = () => store.commit('cart/clear')

    // Оплата всех заявок из корзины: номера уходят через запятую,
    // бэкенд создаёт несколько заказов под одним платежом.
    const paySelected = () => {
      const ids = store.getters['cart/getIds']
      if (!ids.length) return
      isMenuOpen.value = false
      router.push({ name: 'payment', query: { vouchers: ids.join(',') } }).catch(() => {})
    }

    const perfectScrollbarOptions = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    return {
      isMenuOpen,
      items,
      count,
      removeItem,
      clearCart,
      paySelected,
      perfectScrollbarOptions,

      icons: {
        mdiCartOutline,
        mdiClose,
      },
    }
  },
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.app-bar-cart-content-container {
  .cart-btn-list-item {
    padding-top: 14px;
    padding-bottom: 14px;
    min-height: unset;
  }
}

.ps-cart-items {
  max-height: calc(var(--vh, 1vh) * 80);
}

// Ширина фиксированная (min = max в пропсах v-menu), иначе меню «прыгает»
// под самый длинный пункт и сужается, когда его убрали.
.cart-menu-content {
  @media #{map-get($display-breakpoints, 'xs-only')} {
    min-width: calc(100vw - (1.5rem * 2)) !important;
    max-width: calc(100vw - (1.5rem * 2)) !important;
    left: 50% !important;
    transform: translateX(-50%);
  }
}
</style>
